<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="sales"
      :pagination.sync="pagination"
      :loading="loading"
      hide-actions
    >
      <template slot="items" slot-scope="props">
          <td>{{ gerPeriodString(props.item.year, props.item.month) }}</td>
          <td>{{ props.item.sale_count }}</td>
          <td>{{ (props.item.sale_amount / 10).toFixed(1) }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from 'moment'

import locationService from '@/services/location'

export default {
  props: {
    locationId: [String, null]
  },

  data () {
    return {
      loading: false,
      headers: [
        { text: 'Period', value: 'yearmonth' },
        { text: 'No. of Transactions', value: 'sale_count' },
        { text: 'Amount', value: 'sale_amount' }
      ],
      pagination: {
        rowsPerPage: -1,
        descending: true
      },
      sales: []
    }
  },

  computed: {
  },

  methods: {
    async getSales () {
      this.loading = true

      const { data } = await locationService.sales(this.locationId)
      this.sales = data.data

      this.loading = false
    },

    gerPeriodString (year, month) {
      const startDate = moment([year, month - 1]);
      const endDate = moment(startDate).endOf('month');
      const current = moment()

      const startStr = startDate.format('YYYY-MM-DD')

      let endStr = 'Present'

      if (!current.isBefore(endDate)) {
        endStr = endDate.format('YYYY-MM-DD')
      }

      return `${startStr} - ${endStr}`;
    }
  },

  created () {
    this.getSales()
  }
}
</script>

<style>

</style>
